/**
 * The routes this feature owns.
 *
 * Deliberately **not** in `@belong/common`'s `PATHS`: that registry is the
 * legacy shared route map, it is frozen, and routes only this app's reviews
 * page, header and footer use have no business in a package both legacy apps
 * build against. Owning them here is also what the new stack does — a feature
 * package exports its own `./urls` — so a later port of this page moves the
 * strings with the feature instead of leaving them behind in shared constants.
 */
export const REVIEWS_URLS = {
  REVIEWS: '/reviews',
} as const;

/** The site, for the absolute URLs that structured data and sitemaps need. */
export const SITE_URL = 'https://belonghome.com';

/**
 * The path for one page of the feed.
 *
 * Page one is `/reviews` and nothing else: `/reviews/page/1` would be the same
 * forty-five reviews at a second URL, which is a duplicate to be canonicalised
 * away rather than a page to publish. The route that serves it redirects.
 */
export function reviewsPageHref(page: number): string {
  return page <= 1
    ? REVIEWS_URLS.REVIEWS
    : `${REVIEWS_URLS.REVIEWS}/page/${page}`;
}
